module.exports = ".dropdown-toggle::after {\n  display: none; }\n\n.full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/mch-navigation/mch-navigation.component.scss
// module id = 634
// module chunks = 0